import { render, staticRenderFns } from "./OrderTabActivities.vue?vue&type=template&id=43940eea&"
import script from "./OrderTabActivities.vue?vue&type=script&lang=js&"
export * from "./OrderTabActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports